"use strict";
/*******************************************************************************

    Contains definition for the unspent transaction output

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnspentTxOutput = void 0;
var Amount_1 = require("../../common/Amount");
var Hash_1 = require("../../common/Hash");
var JSONValidator_1 = require("../../utils/JSONValidator");
var jsbi_1 = __importDefault(require("jsbi"));
/**
 * Define the unspentTxOutput
 */
var UnspentTxOutput = /** @class */ (function () {
    /**
     * Constructor
     * @param utxo          The hash of the UTXO key
     * @param type          The type of the transaction output
     * @param unlock_height The height of the block to be unlock
     * @param amount        The amount value of this utxo, in 1/10^7
     * @param height        The height of the block on created
     * @param time          The time of the block on created
     * @param lock_type     The lock type
     * @param lock_bytes    The lock bytes
     */
    function UnspentTxOutput(utxo, type, unlock_height, amount, height, time, lock_type, lock_bytes) {
        this.utxo = utxo;
        this.type = type;
        this.unlock_height = unlock_height;
        this.amount = amount;
        this.height = height;
        this.time = time ? time : 0;
        this.lock_type = lock_type ? lock_type : 0;
        this.lock_bytes = lock_bytes ? lock_bytes : "";
    }
    /**
     * The reviver parameter to give to `JSON.parse`
     *
     * This function allows to perform any necessary conversion,
     * as well as validation of the final object.
     *
     * @param key   Name of the field being parsed
     * @param value The value associated with `key`
     * @returns A new instance of `UnspentTxOutput` if `key == ""`, `value` otherwise.
     */
    UnspentTxOutput.reviver = function (key, value) {
        if (key !== "")
            return value;
        JSONValidator_1.JSONValidator.isValidOtherwiseThrow("UnspentTxOutput", value);
        return new UnspentTxOutput(new Hash_1.Hash(value.utxo), value.type, jsbi_1.default.BigInt(value.unlock_height), Amount_1.Amount.make(value.amount), jsbi_1.default.BigInt(value.height), value.time, value.lock_type, value.lock_bytes);
    };
    return UnspentTxOutput;
}());
exports.UnspentTxOutput = UnspentTxOutput;
//# sourceMappingURL=UnspentTxOutput.js.map